import { Team__Aliados } from "./teams/Aliados";
import { Team__Apaches } from "./teams/Apaches";
import { Team__BallBrothers } from "./teams/BallBrothers";
import { Team__Cerveceros_MAIN } from "./teams/Cerveceros_MAIN";
import { Team__MeanMachine } from "./teams/MeanMachine";
import { Team__Nogaleros } from "./teams/Nogaleros";
import { Team__UT } from "./teams/UT";
import { Team__XLobos } from "./teams/XLobos";

export const teamList_2025_mensA = [
  Team__Aliados,
  Team__Apaches,
  Team__BallBrothers,
  Team__Cerveceros_MAIN,
  Team__MeanMachine,
  Team__Nogaleros,
  Team__UT,
  Team__XLobos,
];
